require('./bootstrap');

/**
* Nectar Button custom coloring
*
* @since 3.0
*/
function coloredButtons() {

    $('.nectar-button.see-through[data-color-override], .nectar-button.see-through-2[data-color-override], .nectar-button.see-through-3[data-color-override]').each(function () {
        
        var $usingMaterialSkin = true;
        $(this).css('visibility', 'visible');
        
        if ($(this).hasClass('see-through-3') && $(this).attr('data-color-override') == 'false') {
            return true;
        }
        
        var $color;
        var $that;
        
        if ($(this).attr('data-color-override') != 'false') {
            $color = $(this).attr('data-color-override');
        } else {
            
            if ($(this).parents('.dark').length > 0) {
                $color = '#000000';
            }	else {
                $color = '#ffffff';
            }
            
        }
        
        if (!$(this).hasClass('see-through-3')) {
            $(this).css('color', $color);
        }
        
        $(this).find('i').css('color', $color);
        
        var colorInt        = parseInt($color.substring(1), 16);
        var $hoverColor     = ($(this).has('[data-hover-color-override]')) ? $(this).attr('data-hover-color-override') : 'no-override';
        var $hoverTextColor = ($(this).has('[data-hover-text-color-override]')) ? $(this).attr('data-hover-text-color-override') : '#fff';
        
        var R = (colorInt & 0xFF0000) >> 16;
        var G = (colorInt & 0x00FF00) >> 8;
        var B = (colorInt & 0x0000FF) >> 0;
        
        var $opacityStr = ($(this).hasClass('see-through-3')) ? '1' : '0.75';
        
        $(this).css('border-color', 'rgba(' + R + ',' + G + ',' + B + ',' + $opacityStr + ')');
        
        // Material theme skin buttons w/ icons starting
        if ($usingMaterialSkin) {
            $(this).find('i').css({
                'background-color': 'rgba(' + R + ',' + G + ',' + B + ',1)',
                'box-shadow': '0px 8px 15px rgba(' + R + ',' + G + ',' + B + ',0.24)'
            });
        }
        
        if ($(this).hasClass('see-through')) {
            
            $that = $(this);
            
            $(this).on('mouseenter touchstart', function () {
                $that.css('border-color', 'rgba(' + R + ',' + G + ',' + B + ',1)');
            });
            
            $(this).on('mouseleave touchtouchend', function () {
                $that.css('border-color', 'rgba(' + R + ',' + G + ',' + B + ',1)');
                $opacityStr = ($(this).hasClass('see-through-3')) ? '1' : '0.75';
                $that.css('border-color', 'rgba(' + R + ',' + G + ',' + B + ',' + $opacityStr + ')');
            });
            
        } else {
            
            $(this).find('i').css('color', $hoverTextColor);
            
            if ($hoverColor != 'no-override') {
                
                $that = $(this);
                
                $(this).on('mouseenter touchstart', function () {
                    
                    $that.css({
                        'border-color': $hoverColor,
                        'background-color': $hoverColor,
                        'color': $hoverTextColor
                    });
                    
                    // Material buttons w/ icons over
                    if ($usingMaterialSkin) {
                        $that.find('i').css({
                            'background-color': '',
                            'box-shadow': ''
                        });
                    }
                });
                
                $(this).on('mouseleave touchtouchend', function () {
                    
                    $opacityStr = ($(this).hasClass('see-through-3')) ? '1' : '0.75';
                    
                    if ($usingMaterialSkin) {
                        $that.find('i').css({
                            'background-color': 'rgba(' + R + ',' + G + ',' + B + ',1)',
                            'box-shadow': '0px 8px 15px rgba(' + R + ',' + G + ',' + B + ',0.24)'
                        });
                    }
                    
                    if (!$that.hasClass('see-through-3')) {
                        $that.css({
                            'border-color': 'rgba(' + R + ',' + G + ',' + B + ',' + $opacityStr + ')',
                            'background-color': 'transparent',
                            'color': $color
                        });
                    } else {
                        $that.css({
                            'border-color': 'rgba(' + R + ',' + G + ',' + B + ',' + $opacityStr + ')',
                            'background-color': 'transparent'
                        });
                    }
                    
                });

            } else {
                
                $that = $(this);
                
                $(this).on('mouseenter touchstart', function () {
                    
                    $that.css({
                        'border-color': $hoverColor,
                        'color': $hoverTextColor
                    });
                    
                });
                
                $(this).on('mouseleave touchtouchend', function () {
                    
                    $opacityStr = ($that.hasClass('see-through-3')) ? '1' : '0.75';
                    $that.css({
                        'border-color': 'rgba(' + R + ',' + G + ',' + B + ',' + $opacityStr + ')',
                        'color': $hoverTextColor
                    });
                    
                });

            }
        }
    });

    $('.nectar-button:not(.see-through):not(.see-through-2):not(.see-through-3)[data-color-override]').each(function () {
        
        $(this).css('visibility', 'visible');
        
        if ($(this).attr('data-color-override') != 'false') {
            
            var $color = $(this).attr('data-color-override');

            $(this)
                .removeClass('accent-color')
                .removeClass('extra-color-1')
                .removeClass('extra-color-2')
                .removeClass('extra-color-3')
                .css('background-color', $color);
        }
        
    });
}

$(document).ready(function ($) {
    coloredButtons();
});